import { render } from "./Header-App.vue?vue&type=template&id=cc0b0ae6"
import script from "./Header-App.vue?vue&type=script&lang=js"
export * from "./Header-App.vue?vue&type=script&lang=js"

import "./Header-App.vue?vue&type=style&index=0&id=cc0b0ae6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__